module.exports = __webpack_public_path__ + "static/media/organization-office-building-notification-green.454cece2.svg";